import { render, staticRenderFns } from "./ZhDetails.vue?vue&type=template&id=1c64a464&scoped=true"
import script from "./ZhDetails.vue?vue&type=script&lang=js"
export * from "./ZhDetails.vue?vue&type=script&lang=js"
import style0 from "./ZhDetails.vue?vue&type=style&index=0&id=1c64a464&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c64a464",
  null
  
)

export default component.exports